<div class="app-selector-sidebar">
  <div class="sidebar-header">
    <h3>Add Apps</h3>
    <p class="subtitle">Choose apps to add to your collection</p>
  </div>

  <!-- Error Message -->
  <div *ngIf="error" class="error-message">
    <div class="error-content">
      <span>{{ error }}</span>
      <button class="error-close" (click)="clearError()" aria-label="Close error">×</button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading apps...</p>
  </div>

  <!-- Main Content -->
  <div *ngIf="!isLoading" class="sidebar-content">
    <!-- Category Filter -->
    <div class="filter-section">
      <label for="categoryFilter">Filter by Category:</label>
      <select 
        id="categoryFilter" 
        [(ngModel)]="selectedCategoryName" 
        (change)="onCategoryChange()"
        class="category-select">
        <option value="">All Categories</option>
        <option *ngFor="let category of categories" [value]="category.name">
          {{ category.name }}
        </option>
      </select>
    </div>

    <!-- Apps List -->
    <div class="apps-section">
      <h4 class="section-title">
        Available Apps 
        <span class="app-count">({{ filteredApplications.length }})</span>
      </h4>
      
      <div *ngIf="filteredApplications.length === 0" class="no-apps-message">
        <p>No apps found for the selected category.</p>
      </div>

      <div class="apps-list">
        <div *ngFor="let app of filteredApplications" class="app-item">
          <label class="app-checkbox-container">
            <input 
              type="checkbox" 
              [checked]="isAppSelected(app.appliId)"
              [attr.data-app-id]="app.appliId"
              (change)="onAppToggle(app, $event)"
              class="app-checkbox">
            
            <div class="app-info">
              <div class="app-icon-container">
                <img 
                  *ngIf="app.androidImageUrl" 
                  [src]="app.androidImageUrl" 
                  [alt]="app.name + ' icon'"
                  class="app-icon"
                  (error)="onImageError($event)">
                <div *ngIf="!app.androidImageUrl" class="app-icon-placeholder">
                  {{ app.name.charAt(0).toUpperCase() }}
                </div>
              </div>
              
              <div class="app-details">
                <span class="app-name">{{ app.name }}</span>
                <span class="app-category">{{ app.category }}</span>
                <span class="app-subcategory">{{ app.subCategory }}</span>
              </div>
            </div>
            
            <div class="checkbox-indicator">
              <span class="checkmark">✓</span>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- Stats Footer -->
  <div *ngIf="!isLoading" class="sidebar-footer">
    <div class="stats">
      <span class="stat-item">
        <strong>{{ userApps.length }}</strong> apps selected
      </span>
      <span class="stat-item">
        <strong>{{ applications.length }}</strong> total available
      </span>
    </div>
  </div>
</div>
